angular.module('ihestiaMenuTopMenu',
  ['ihestia-menu-templates-app', 'ihestiaCommonDirectives', 'ihestiaCommonComponents', 'ihestiaCommonDirectives.apk']
);